import React from "react";
import { CheckCircle } from "lucide-react";
import Button from "react-bootstrap/Button";

const tiers = [
  {
    name: "Tier 1 – Homework Club Essentials",
    price: "$30 / month",
    note: "Perfect for students who need a structured space for homework and light enrichment. First session FREE!",
    url: "https://square.link/u/AT5O4kgM",
    features: [
      "Weekly Homework Help (90 min)",
      "Access to Peer Mentors",
      "Light enrichment activities (games, reading, creative time)",
    ],
  },
  {
    name: "Tier 2 – Homework + Tech Basics",
    price: "$50 / month",
    note: "Ideal for students ready to explore technology while staying on top of their homework.",
    url: "https://square.link/u/LLan8NRA",
    features: [
      "Everything in Tier 1",
      "Monthly Intro to Coding & Robotics Workshops",
      "Creative tech projects",
    ],
  },
  {
    name: "Tier 3 – Full Tech & Enrichment Package",
    price: "$90 / month",
    note: "For students who love hands-on learning and want to dive deeper into tech and sustainability.",
    url: "https://square.link/u/pNH8tMgD",
    features: [
      "Everything in Tier 2",
      "Weekly Tech Workshops (coding, electronics, AI basics)",
      "Urban Gardening Project (hands-on sustainability activity)",
      "Small project showcases for parents & community",
    ],
  },
  {
    name: "Tier 4 – Ambassador & Leadership Track (Premium)",
    price: "$120 / month",
    note: "Exclusive program for students committed to leadership, community service, and advanced tech skills.",
    url: "https://square.link/u/ctopJBKV",
    features: [
      "Everything in Tier 3",
      "Leadership & Community Service Training",
      "Access to Competitions, Events & Extra Coaching",
      "Opportunities to run/lead parts of the Homework Club",
    ],
  },
];

export default function TiersPage() {
  return (
    <div className="min-h-screen py-16 px-6 pt-32 sm:pt-40">
      <h1 className="text-3xl font-bold text-center mb-10">
        Tiered Enrichment Plans
      </h1>
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-2 max-w-6xl mx-auto">
        {tiers.map((tier, idx) => (
          <div
            key={idx}
            className="rounded-2xl bg-white border border-gray-200 p-6 flex flex-col justify-between shadow-md hover:shadow-lg transition-shadow"
          >
            <div>
              {/* Card Header */}
              <div className="flex flex-col mb-4">
                <h2 className="text-xl font-semibold text-gray-800">
                  {tier.name}
                </h2>
                <p className="text-lg font-bold text-green-600">{tier.price}</p>
                {tier.note && (
                  <p className="text-sm text-gray-500">{tier.note}</p>
                )}
              </div>

              {/* Features */}
              <ul className="space-y-2 mb-6">
                {tier.features.map((feature, fIdx) => (
                  <li key={fIdx} className="flex items-start space-x-2">
                    <CheckCircle className="text-green-500 w-5 h-5 mt-0.5" />
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* CTA Button (React Bootstrap) */}
            <Button
               as="a"
  href={tier.url}
  target="_blank"
  rel="noopener noreferrer"
  variant="success"
  className="mt-auto rounded-xl shadow"
            >
              Sign Up
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
}
